import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Login from '~/pages/Login';

import Register from '~/pages/Register';
import Profile from '~/pages/Profile';
import Indications from '~/pages/Indications';
import NewIndication from '~/pages/NewIndication';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/profile" component={Profile} />
      <Route path="/indications" exact component={Indications} />
      <Route path="/indications/new" component={NewIndication} />
      <Route
        exact
        path="*"
        render={() => (
          <h1
            style={{
              display: 'flex',
              height: '100vh',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Error Code 404
          </h1>
        )}
      />
    </Switch>
  );
}
